
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'IntegrationsComingSoon',

  setup() {
    const { t } = useI18n();
    const route = useRoute();

    // `focusName` (label lisible) est passé en query par les points d'entrée qui
    // connaissent le nom de l'intégration ; à défaut on retombe sur le slug
    // (`focus`). Aucun appel réseau : la résolution reste purement URL → écran.
    const focusName = computed<string>(() => {
      const name = route.query.focusName;
      const slug = route.query.focus;
      const raw = (Array.isArray(name) ? name[0] : name)
        ?? (Array.isArray(slug) ? slug[0] : slug);
      return raw ? String(raw) : '';
    });

    return { t, focusName };
  },
});
